<template>
  <v-sheet color="transparent" class="headline" :class="'mx-n' + extendX">
    <div class="headline__wrap">
      <slot name="prepend-btn"></slot>
      <div class="headline__content">
        <h3 class="text-h6 my-3">
          <slot> Title </slot>
        </h3>
      </div>
      <div
        class="headline__actions__group"
        :class="extendX > 0 ? 'mr-' + (extendX - 1) : 'mr-4'"
      >
        <slot name="btn-text"></slot>
        <slot name="btn-icon-1"></slot>
        <slot name="btn-icon-2"></slot>
        <slot name="btn-icon-3"></slot>
        <slot name="btn-overflow"></slot>
      </div>
    </div>
    <v-divider v-if="!hideDivider"></v-divider>
  </v-sheet>
</template>

<script>
export default {
  name: "HeadlineBar",
  props: {
    extendX: {
      type: Number,
      default: 0,
    },
    hideDivider: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="sass" scoped>
.headline
  .headline__wrap
    align-items: center
    display: flex
    flex: 1 1 100%

    .headline__content
      align-items: center
      align-self: center
      display: flex
      flex-wrap: wrap
      flex: 1 1
      overflow: hidden
      padding: 12px 24px
</style>

<style lang="sass">
.headline
  .headline__wrap
    > .v-btn:first-child
      margin-left: 16px

    .headline__actions__group
      > .v-btn
        margin-left: 8px
</style>